import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './styles/tokens.css'
import './styles/base.css'
import './styles/app.css'
import './styles/print.css'

const container = document.getElementById('root')
if (!container) throw new Error('Der Einhängepunkt #root fehlt im HTML')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
